import React from "react";
import { FILTERS } from "../utils/palette";
import classNames from "../helpers/classNames";
import { useI18n } from "../contexts/I18nContext";
import { Dices, Flame, Snowflake, Sun, Moon, Sunrise, Stars, Leaf, Flower, Rose, Waves, Grape, Cloud, Candy, CircleMinusIcon, Palette, Radio, Clock, Zap, Sparkles, CloudRain, Droplets, Eclipse, TreePine, Wheat, House } from "lucide-react";

const filterIcons = {
  "Random": <Dices size={26} className="inline-block pb-1" />,
  "Warm": <Flame size={26} className="inline-block text-orange-400 pb-1"/>,
  "Summer": <Sun size={26} className="inline-block text-amber-400 pb-1"/>,
  "Spring": <Flower size={26} className="inline-block text-pink-300 pb-1"/>,
  "Autumn": <Leaf size={26} className="inline-block text-orange-600 pb-1"/>,
  "Winter": <Snowflake size={26} className="inline-block text-blue-300 pb-1"/>,
  "Light": <Sun size={26} className="inline-block text-yellow-400 pb-1"/>,
  "Dark": <Moon size={26} className="inline-block text-slate-600 pb-1"/>,
  "Vivid": <Stars size={26} className="inline-block text-yellow-300 pb-1"/>,
  "Similar": <Palette size={26} className="inline-block text-slate-400 pb-1"/>,
  "Greenish": <Sparkles size={26} className="inline-block text-emerald-400 pb-1"/>,
  "Yellowish": <Wheat size={26} className="inline-block text-yellow-500 pb-1"/>,
  "Reddish": <Rose size={26} className="inline-block text-rose-400 pb-1"/>,
  "Blueish": <Waves size={26} className="inline-block text-cyan-400 pb-1"/>,
  "Purplish": <Grape size={26} className="inline-block text-violet-400 pb-1"/>,
  "Neutral": <CircleMinusIcon size={26} className="inline-block text-slate-400 pb-1"/>,
  "Moody": <CloudRain size={26} className="inline-block text-slate-500 pb-1"/>,
  "Pastel": <Candy size={26} className="inline-block text-pink-300 pb-1"/>,
  "Retro": <Radio size={26} className="inline-block text-amber-600 pb-1"/>,
  "Vintage": <Clock size={26} className="inline-block text-stone-500 pb-1"/>,
  "Neon": <Zap size={26} className="inline-block text-fuchsia-400 pb-1"/>,
  "Day": <Sunrise size={26} className="inline-block text-yellow-400 pb-1"/>,
  "Night": <Moon size={26} className="inline-block text-indigo-400 pb-1"/>,
  "Dark": <Eclipse size={26} className="inline-block text-slate-700 pb-1"/>,
  "Earth": <TreePine size={26} className="inline-block text-green-700 pb-1"/>,
  "Skin": <Droplets size={26} className="inline-block text-orange-300 pb-1"/>,
  "Cottage": <House size={26} className="inline-block text-rose-400 pb-1"/>,
};

export default function FilterSidebar({ 
  active, 
  onChange, 
  similarSubfilter, 
  onSimilarSubfilterChange, 
  isSimilarMode 
}) {
  const { t } = useI18n();

  return (
    <aside className="card-elegant p-3 h-fit max-h-[70vh] overflow-y-auto lg:max-h-none lg:overflow-visible lg:card-elegant lg:p-3">
      <div className="mb-3">
        <h3 className="text-base font-display font-semibold text-slate-800 mb-1.5">{t('filters.title')}</h3>
        <div className="w-12 h-0.5 bg-gradient-to-r from-rose-pastel-400 to-lavender-400 rounded-full"></div>
      </div>

      <div className="grid grid-cols-4 gap-1.5">
        {FILTERS.map(f => (
          <div key={f}>
            <button
              onClick={() => onChange(f)}
              className={classNames(
                "w-full p-1.5 rounded-xl text-center transition-all duration-200 group",
                active === f
                  ? "bg-gradient-to-r from-rose-pastel-400 to-rose-pastel-500 text-white shadow-soft-lg"
                  : "bg-white/50 hover:bg-white/80 text-slate-700 hover:shadow-soft border border-rose-pastel-100/50"
              )}
              aria-pressed={active === f}
            >
              <div className="flex flex-col items-center gap-0.5">
                <span className="text-base leading-none">{filterIcons[f] || "🎨"}</span>
                <div className={classNames(
                  "font-medium text-[10px] leading-tight",
                  active === f ? "text-white" : "text-slate-800"
                )}>
                  {t(`filters.names.${f}`)}
                </div>
              </div>
            </button>
          </div>
        ))}
      </div>
    </aside>
  );
}
